import { useEffect, useState } from "react";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import { api } from "@/lib/api";

export default function AdminPage() {
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!localStorage.getItem("tc_admin_token")) {
      setState("login");
      return;
    }
    api
      .get("/auth/me")
      .then(() => setState("authed"))
      .catch(() => {
        localStorage.removeItem("tc_admin_token");
        setState("login");
      });
  }, []);

  if (state === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink font-mono text-xs uppercase tracking-[0.3em] text-gold">
        Loading…
      </div>
    );
  }
  if (state === "login") return <AdminLogin onSuccess={() => setState("authed")} />;
  return <AdminDashboard onLogout={() => setState("login")} />;
}
